import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import router from "@/router"
import i18n from "@/lang";
import trans from "@/components/translateText.vue"
import Image from "@/components/Image.vue"
import config from './utils/config'
import { createPinia } from 'pinia';

// const setRemSize = () => {
//   const baseSize = 16;
//   const width = window.innerWidth;
//   document.documentElement.style.fontSize = baseSize * (width / 1920) + 'px';
// };

// window.addEventListener('resize', setRemSize);
// setRemSize();

// 解决 ElTable 自动宽度高度导致的「ResizeObserver loop limit exceeded」问题
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}


const app = createApp(App);
const pinia = createPinia();
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.config.errorHandler = (err, instance, info) => {
  console.error('Global error handler:', err);
  // 这里可以选择不显示错误信息
};

document.title = config.title;

app.use(ElementPlus);
app.use(router);
app.use(i18n);
app.use(pinia);
app.component('trans', trans);
app.component('Image', Image)
app.mount('#app');
